import {Helpers} from '@app/shared';
import {BaseModel, BaseModelInterface} from '@app/abstracts';
export interface LanguageInterface extends BaseModelInterface {
  created_at: number | Date;
  name: string;
  display_name: string;
  language_manager_name: string;
}
export interface LanguagePayload {
  name: string;
  display_name: string;
  language_manager_name: string;
}
type LanguagePayloadKey = keyof LanguagePayload;
export class Language extends BaseModel< LanguageInterface, LanguagePayload> {
  /** Short function to get label of instance */
  getLabel(): string {
    return `${this.props.name}`;
  }
  /** Populate the current instance from an object */
  fromObject(object: LanguageInterface): void {
    this.props = Object.assign({}, object);
        this.props.created_at = Helpers.convertToDate(this.props.created_at);
    this.next();
  }
  /** Convert the current instance to an object */
  toObject(): LanguageInterface {
    const props = Object.assign({}, this.props);
        props.created_at = Helpers.convertToTimestamp(props.created_at);
    return props;
  }
  /** Convert an instance to an object to be sent to the API */
  toPayload(): LanguagePayload {
    const raw = this.toObject();
    const allowed = this.allowedKeys();
    const payload = Object.keys(raw)
      .filter(key => allowed.includes(< any>key))
      .reduce((o, k) => { o[k] = raw[k]; return o; }, {} as LanguageInterface);
    return payload as LanguagePayload;
  }
  /** List allowed keys to be sent to the API */
  protected allowedKeys(): LanguagePayloadKey[] {
  	return [
      'name',
      'display_name',
      'language_manager_name',
  	];
  }
}
